import angular from 'angular';
import { Lang } from 'Roblox';

const recommendations = angular
  .module('recommendations', ['robloxApp', 'thumbnails', 'recommendationsAppTemplates'])
  .config([
    'languageResourceProvider',
    languageResourceProvider => {
      languageResourceProvider.setLanguageKeysFromFile(Lang['Feature.Recommendations']);
    }
  ]);

export default recommendations;
